<template>
    <client-page>
        <sub-visual-full bg="/images/sub/visual/sv3.jpg" video="/images/sub/visual/sv3.mp4">
            <div class="text-ani-wrap">
                <div class="text-ani">
                    <h2 class="font-weight-bold">제휴문의</h2>
                </div>
            </div>
        </sub-visual-full>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">
                        풍부한 경험과 글로벌 네트워크를 바탕으로 <br class="d-none d-md-block">
                        고객사의 브랜드를 강화합니다.
                    </h3>
                </div>
                <h5 class="tit-txt pb-2 border-bottom border-2 border-lg-4 border-color-point mx-auto mb-50 mb-lg-74" style="width: fit-content">신규사업 제휴 절차</h5>
                <div class="steps mx-sm-auto" style="width: fit-content">
                    <div class="step d-md-flex align-start pb-20 pb-lg-50">
                        <div class="d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0">
                            <p class="page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100" data-aos="fade-right">
                                STEP 01
                            </p>
                            <span class="step__point mr-6 mr-md-0"></span>
                        </div>
                        <div class="ml-md-24 ml-lg-60" data-aos="fade-left">
                            <h5 class="tit-txt font-weight-bold">
                                미팅
                            </h5>
                            <p class="page-text--sm color-grey-7 mt-2 mt-lg-0">
                                고객사의 단기·장기 목표 확인 후, 세일즈 솔루션과 성장 전략 제시
                            </p>
                        </div>
                    </div>
                    <div class="step d-md-flex align-start pb-20 pb-lg-50">
                        <div class="d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0">
                            <p class="page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100" data-aos="fade-right">
                                STEP 02
                            </p>
                            <span class="step__point mr-6 mr-md-0"></span>
                        </div>
                        <div class="ml-md-24 ml-lg-60" data-aos="fade-left">
                            <h5 class="tit-txt font-weight-bold">
                                테스트
                            </h5>
                            <p class="page-text--sm color-grey-7 mt-2 mt-lg-0">
                                테스트 캠페인을 통해 시장 가능성 확인
                            </p>
                        </div>
                    </div>
                    <div class="step d-md-flex align-start pb-20 pb-lg-50">
                        <div class="d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0">
                            <p class="page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100" data-aos="fade-right">
                                STEP 03
                            </p>
                            <span class="step__point mr-6 mr-md-0"></span>
                        </div>
                        <div class="ml-md-24 ml-lg-60" data-aos="fade-left">
                            <h5 class="tit-txt font-weight-bold">
                                개발
                            </h5>
                            <p class="page-text--sm color-grey-7 mt-2 mt-lg-0">
                                테스트 결과를 반영하여 캠페인 운영 절차 수립
                            </p>
                        </div>
                    </div>
                    <div class="step d-md-flex align-start">
                        <div class="d-flex flex-row-reverse flex-md-row align-center mt-lg-4 mb-8 mb-md-0">
                            <p class="page-text--sm font-weight-bold mr-md-12 mr-lg-20 w-100" data-aos="fade-right">
                                STEP 04
                            </p>
                            <span class="step__point mr-6 mr-md-0"></span>
                        </div>
                        <div class="ml-md-24 ml-lg-60" data-aos="fade-left">
                            <h5 class="tit-txt font-weight-bold">
                                고객사 관리
                            </h5>
                            <p class="page-text--sm color-grey-7 mt-2 mt-lg-0">
                                캠페인 결과에 대한 분석 및 보고 후, 정식 런칭 및 장기 파트너십 구축
                            </p>
                        </div>
                    </div>
                </div>
            </v-container>
        </section>

        <section class="section text-center" style="background-image: url(/images/sub/affiliate/banner.jpg)">
            <v-container>
                <h4 class="tit color-white mb-12 mb-lg-24" data-aos="fade-down">
                    세일즈웍스는 <br>
                    다양한 사업 파트너와의 협업을 기대하고 있습니다.
                </h4>
                <div class="d-flex flex-column flex-sm-row justify-center align-center color-grey-d" data-aos="fade-up">
                    <a href="mailto:info@salesworks.asia" target="_blank" class="d-block tit-txt">info@salesworks.asia</a>
                    <span class="line mx-12 mx-lg-20 d-none d-sm-block"></span>
                    <a href="tel:1600-3939" class="d-block tit-txt mt-4 mt-sm-0">1600-3939</a>
                </div>
            </v-container>
        </section>

        <section class="section bg-grey">
            <v-container>

                <div class="tit-wrap">
                    <h3 class="tit">
                        세계를 무대로 25년 이상 쌓아온 전문성이 <br class="d-none d-md-block">
                        결과의 차이를 만듭니다.
                    </h3>
                </div>
                                    
                <div class="mb-50 mb-lg-80">
                    <v-row class="flex-column-reverse flex-md-row">
                        <v-col cols="12" md="6" lg="5" xl="4" class="d-md-flex flex-md-column justify-md-center" data-aos="fade-right">
                            <div class="under-line mb-16 mb-lg-30 pb-18 pb-lg-34">
                                <h3 class="tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14">01</h3>
                                <h5 class="tit-txt font-weight-bold">
                                    최적화된 영업망
                                </h5>
                            </div>
                            <p class="dot-text mb-4 mb-lg-14">
                                전국 주요 도시에 지점을 운영하여 지역에 제한 없는
                                전문 인재 파견이 가능합니다.
                            </p>
                            <p class="dot-text">
                                추가 비용 없이 영업 규모를 유동적으로 조정하고
                                확장할 수 있습니다.
                            </p>
                        </v-col>
                        <v-col cols="12" md="6" lg="7" offset-xl="1" data-aos="fade-left">
                            <v-img src="/images/sub/affiliate/s2-img1.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                </div>

                <div class="mb-50 mb-lg-80 text-lg-right">
                    <v-row>
                        <v-col cols="12" md="6" lg="7" data-aos="fade-right">
                            <v-img src="/images/sub/affiliate/s2-img2.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="12" md="6" lg="5" xl="4" offset-xl="1" class="d-md-flex flex-md-column justify-md-center align-lg-end" data-aos="fade-left">
                            <div class="under-line mb-16 mb-lg-30 pb-18 pb-lg-34">
                                <h3 class="tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14">02</h3>
                                <h5 class="tit-txt font-weight-bold">
                                    세일즈 전문성
                                </h5>
                            </div>
                            <p class="dot-text mb-4 mb-lg-14">
                                아시아 8개국에서 25년 이상 쌓은 경험과 노하우로 <br class="d-none d-lg-block">
                                고객사의 영업을 대행합니다.
                            </p>
                            <p class="dot-text">
                                홍보를 통해 잠재 고객을 확보하고 시장의 규모를 <br class="d-none d-lg-block">
                                확대합니다.
                            </p>
                        </v-col>
                    </v-row>
                </div>

                <div class="mb-50 mb-lg-80">
                    <v-row class="flex-column-reverse flex-md-row">
                        <v-col cols="12" md="6" lg="5" xl="4" class="d-md-flex flex-md-column justify-md-center" data-aos="fade-right">
                            <div class="under-line mb-16 mb-lg-30 pb-18 pb-lg-34">
                                <h3 class="tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14">03</h3>
                                <h5 class="tit-txt font-weight-bold">
                                    솔루션 제공
                                </h5>
                            </div>
                            <p class="dot-text mb-4 mb-lg-14">
                                보다 나은 영업 실적을 원하는 기업의 영업을
                                대행합니다.
                            </p>
                            <p class="dot-text">
                                타겟 고객층에 대한 철저한 분석과 평가를 통해 비용
                                대비 최적의 효과를 도출합니다.
                            </p>
                        </v-col>
                        <v-col cols="12" md="6" lg="7" offset-xl="1" data-aos="fade-left">
                            <v-img src="/images/sub/affiliate/s2-img3.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                </div>

                <div class="text-lg-right">
                    <v-row>
                        <v-col cols="12" md="6" lg="7" data-aos="fade-right">
                            <v-img src="/images/sub/affiliate/s2-img4.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="12" md="6" lg="5" xl="4" offset-xl="1" class="d-md-flex flex-md-column justify-md-center align-lg-end" data-aos="fade-left">
                            <div class="under-line mb-16 mb-lg-30 pb-18 pb-lg-34">
                                <h3 class="tit color-point font-weight-bold line-height-1 mb-6 mb-lg-14">04</h3>
                                <h5 class="tit-txt font-weight-bold">
                                    영업 인재 관리
                                </h5>
                            </div>
                            <p class="dot-text mb-4 mb-lg-14">
                                브랜드 홍보대사 그리고 펀드레이저에게 지속적으로 <br class="d-none d-lg-block">
                                전문 교육을 진행합니다.
                            </p>
                            <p class="dot-text">
                                세일즈웍스의 인재들은 전문성과 경쟁력을 갖춘 <br class="d-none d-lg-block">
                                업계 최고의 전문가입니다.
                            </p>
                        </v-col>
                    </v-row>
                </div>

            </v-container>
        </section>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">
                        세일즈웍스 코리아는 고객을 가장 먼저 생각합니다.
                    </h3>
                </div>
                <h5 class="bar-text mb-30 mb-lg-24">
                    브랜드 약속
                </h5>
                <div class="border border-color-light">
                    <v-row no-gutters>
                        <v-col cols="12" md="4" class="pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center border-bottom border-md-bottom-0 border-md-end border-color-light">
                            <v-img src="/images/sub/affiliate/s3-icon1.png" contain max-width="53" class="mb-10 mb-lg-18" data-aos="fade-down"></v-img>
                            <h5 class="tit-txt font-weight-bold mb-4 mb-lg-8" data-aos="fade-up">
                                안정적인 고객 유치
                            </h5>
                            <p class="page-text--sm color-grey-7">
                                보다 나은 영업 실적을 원하는 기업 <br class="d-none d-lg-block">
                                또는 전문 영업팀이 없는 스타트업 <br class="d-none d-lg-block">
                                등에 정확한 타겟 전략으로 맞춤형 <br class="d-none d-lg-block">
                                솔루션을 제공합니다.
                            </p>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center border-bottom border-md-bottom-0 border-md-end border-color-light">
                            <v-img src="/images/sub/affiliate/s3-icon2.png" contain max-width="56" class="mb-10 mb-lg-18" data-aos="fade-down"></v-img>
                            <h5 class="tit-txt font-weight-bold mb-4 mb-lg-8" data-aos="fade-up">
                                브랜드 강화
                            </h5>
                            <p class="page-text--sm color-grey-7">
                                세일즈웍스는 고객 유치는 물론, <br class="d-none d-lg-block">
                                잠재고객 한 명 한 명에게 맞춤형 <br class="d-none d-lg-block">
                                홍보를 하며 긍정적인 이미지를 남기고 <br class="d-none d-lg-block">
                                브랜드의 인지도를 높입니다.
                            </p>
                        </v-col>
                        <v-col cols="12" md="4" class="pa-20 pa-md-30 py-lg-58 d-flex flex-column align-center text-center">
                            <v-img src="/images/sub/affiliate/s3-icon3.png" contain max-width="60" class="mb-10 mb-lg-18" data-aos="fade-down"></v-img>
                            <h5 class="tit-txt font-weight-bold mb-4 mb-lg-8" data-aos="fade-up">
                                투자수익률 보장
                            </h5>
                            <p class="page-text--sm color-grey-7">
                                세일즈웍스는 달성한 실제 성과에만 <br class="d-none d-lg-block">
                                비용을 부과합니다. 따라서 고객사는 <br class="d-none d-lg-block">
                                투자수익률을 보장하고 리스크없이 <br class="d-none d-lg-block">
                                안정적인 고객 확보가 가능합니다.
                            </p>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
export default {
    components: {
        ClientPage,
        SubVisualFull,
    },
};
</script>

<style scoped>
.step__point{
    display: block;
    min-width: 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 1px solid var(--v-primary-base);
    position: relative;
    background-color: #fff;
}
.step__point::after{
    content: "";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: var(--v-primary-base);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.line{
    width: 1px;
    height: 16px;
    background-color: rgba(255, 255, 255, 0.3);
}

@media (min-width:576px){
}
@media (min-width:768px){
    .step{
        position: relative;
    }

    .steps .step:not(:last-child)::before{
        content: "";
        display: block;
        position: absolute;
        width: 1px;
        height: 100%;
        top: 5px;
        left: 72px;
        background-color: var(--border-color-light);
    }
}
@media (min-width:1024px){
    .step__point{
        min-width: 16px;
        width: 16px;
        height: 16px;
    }
    .step__point::after{
        width: 6px;
        height: 6px;
    }
    .steps .step:not(:last-child)::before{
        top: 10px;
        left: 97px;
    }
}
@media (min-width:1200px){
}

</style>